import { create } from 'zustand';

import { BODEGAS, Ubicaciones } from '@/shared/interfaces/erp/inventario';
import { GetBodegasParams, getBodegas, getUbicaciones } from '@/shared/actions/erp/inventario';

interface BodegaStore {
  bodegas: BODEGAS[];
  bodegaAll: BODEGAS[];
  isLoadingbodegas: boolean;
  getBodega: (params?: GetBodegasParams) => Promise<void>;

  ///* bodega y ubicacion en transito
  bodegaTransito: BODEGAS | null;
  ubicacionTransito: Ubicaciones | null;
}

export const useBodegaStore = create<BodegaStore>((set) => ({
  bodegas: [],
  bodegaAll: [],
  isLoadingbodegas: false,
  getBodega: async params => {
    set({ isLoadingbodegas: true });
    const { data } = await getBodegas(params);
    set({ bodegas: data.data.filter(e => !e.es_transito) });
    set({ isLoadingbodegas: false });

    //console.log('store_data', data.data)
    ///* bodega y ubicacion en transito
    const bodegaTransito = data.data.find(e => e.es_transito);
    //console.log('bodegTansito', bodegaTransito)
    if (!bodegaTransito) return;
    set({ bodegaTransito })

    //console.log('bodega_trasito_store', bodegaTransito?.codigo)

    const { data: dataUbicacion } = await getUbicaciones({
      bodega: bodegaTransito?.codigo,
      page_size: 1
    });
    //console.log('store_ubicacion', dataUbicacion);
    set({ ubicacionTransito: dataUbicacion.data.at(0) })

  },

  ///* bodega y ubicacion en transito
  bodegaTransito: null,
  ubicacionTransito: null

}));